import { gql } from "@apollo/client";
import Spacer from "atoms/Spacer";
import Stack from "atoms/Stack";
import { FONT_FAMILY_LEAGUE_GOTHIC } from "helpers/FONT";
import { sum } from "lodash-es";
import TeamAvatar, { TeamAvatarFragment } from "molecules/TeamAvatar";
import { videoPageContext } from "pages/VideoPage";
import React, { useContext } from "react";
import { useComponentSize } from "react-use-size";

export const VideoHeaderFragment = gql`
  fragment VideoHeaderFragment on Game {
    id
    home {
      id
      name
      ...TeamAvatarFragment
    }
    away {
      id
      name
      ...TeamAvatarFragment
    }
    periods {
      number
      name
    }
    events {
      id
      pointsScored
      occurredAtSeconds
      team {
        id
      }
    }
  }
  ${TeamAvatarFragment}
`;

export default function VideoHeader({ game }) {
  const { currentTime, currentPeriodNumber } = useContext(videoPageContext);

  const homeScore = sum(
    game?.events
      .filter((e) => e.team?.id === game.home.id && e.occurredAtSeconds <= currentTime)
      .map((e) => e.pointsScored),
  );

  const awayScore = sum(
    game?.events
      .filter((e) => e.team?.id === game.away.id && e.occurredAtSeconds <= currentTime)
      .map((e) => e.pointsScored),
  );
  const componentSize = useComponentSize();
  const teamNameStyle = {
    fontFamily: FONT_FAMILY_LEAGUE_GOTHIC,
    textTransform: "uppercase",
    ...(componentSize.width < 600 && {
      display: "none",
    }),
  };

  const scoreStyle = {
    fontSize: "1.5em",
    fontWeight: "bold",
  };

  return (
    <Stack
      componentRef={componentSize.ref}
      style={{ flex: "100 1 auto", fontSize: 22 }}
      horizontal
      noWrap
      alignItemsCenter
      padding
    >
      <TeamAvatar team={game?.home} size={32} />
      <div style={teamNameStyle}>{game?.home.name}</div>
      <Spacer />
      <div style={scoreStyle}>{homeScore}</div>
      <div
        style={{
          fontSize: "0.8em",
          opacity: 0.8,
        }}
      >
        {game?.periods.find((p) => p.number === currentPeriodNumber)?.name}
      </div>
      <div style={scoreStyle}>{awayScore}</div>
      <Spacer />
      <div style={teamNameStyle}>{game?.away.name}</div>
      <TeamAvatar team={game?.away} size={32} />
    </Stack>
  );
}
